import { createSelector } from 'reselect';
export var getPriceBreakdownState = function (checkout) { return checkout.priceBreakdown; };
export var getTotalPrice = createSelector(getPriceBreakdownState, function (state) { return state.totalPrice; });
